import request from '@/utils/request'

// 上报配置列表
export function userActionindex(params) {
  return request({
    url: '/ad1/userActionV1/index',
    method: 'get',
    params
  })
}
// 根据账户ID更新上传比例
export function updateRateByAccountId(data) {
  return request({
    url: '/ad1/userAction/updateRateByAccountId',
    method: 'post',
    data
  })
}
// 上报配置新增
export function userActioncreate(data) {
  return request({
    url: '/ad1/userActionV1/create',
    method: 'post',
    data
  })
}
// 上报配置编辑
export function userActionupdate(data) {
  return request({
    url: '/ad1/userActionV1/update',
    method: 'post',
    data
  })
}
// 上报配置编辑
export function userActiondetail(params) {
  return request({
    url: '/ad1/userActionV1/detail',
    method: 'get',
    params
  })
}
// 账号列表
export function accountindex(params) {
  return request({
    url: '/ad1/account/index',
    method: 'get',
    params
  })
}

// 广告主授权
export function builderAuthUrl(params) {
  return request({
    url: '/ad1/account/builderAuthUrl',
    method: 'get',
    params
  })
}
